<p8-settings-page>
  <p8-settings-header [titlePath]="['Banque d\'images']">
    <div *ngIf="! selectingMode">
      <button mat-raised-button color="accent" [routerLink]="['new']" matTooltip="ajouter des images à la bibliothèque">
        AJOUTER IMAGES
      </button>
    </div>

    <div *ngIf="selectingMode">
      <button mat-raised-button color="accent" (click)="openAddModaleImages()"
              matTooltip="ajouter des images à la bibliothèque">
        AJOUTER IMAGES
      </button>
    </div>
  </p8-settings-header>

  <app-data-table
    [dataSource]="dsImages"
    [extraParams]="extraParams"
    [filterDisplay]="true"
    [placeHolderFilter]="'Rechercher une image'"
    [toolTipFilter]="'Rechercher une image'"
    [flexAction]="5" [flexColumn]="90"
    [pageSize]="maxItems" [pageSizesList]="[5,10,25]"
    [columns]="columns" [actions]="actions"
    [showLoader]="true"
    class="p8-cm_data-table__search-full-width">
  </app-data-table>

</p8-settings-page>

